<section>
  <h2>classistatic.net 疎通確認</h2>

  <table>
    <thead>
      <tr>
        <th>URL</th>
        <th>結果</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>https://training-contents.classistatic.net/production.png</td>
        <td>
          <img
            src="https://training-contents.classistatic.net/production.png"
            crossorigin="anonymous"
          />
        </td>
      </tr>
      <tr>
        <td>https://staging-training-contents.classistatic.net/staging.png</td>
        <td>
          <img
            src="https://staging-training-contents.classistatic.net/staging.png"
            crossorigin="anonymous"
          />
        </td>
      </tr>
    </tbody>
  </table>
</section>
